import { Spin } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import style from './style'

const Loader = ({ relative = false }) => (
  <div className={classnames(style.loader, !relative && style.fullscreen)}>
    <Spin />
  </div>
)

Loader.propTypes = {
  relative: PropTypes.bool
}

export default Loader
